var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 0C3.2042 0 0.929688 2.27451 0.929688 5.07024C0.929688 8.53983 5.46708 13.6334 5.66027 13.8485C5.84172 14.0506 6.15852 14.0503 6.33965 13.8485C6.53283 13.6334 11.0702 8.53983 11.0702 5.07024C11.0702 2.27451 8.79569 0 5.99996 0ZM5.99996 7.62122C4.59334 7.62122 3.449 6.47686 3.449 5.07024C3.449 3.66362 4.59337 2.51929 5.99996 2.51929C7.40655 2.51929 8.55088 3.66365 8.55088 5.07027C8.55088 6.47689 7.40655 7.62122 5.99996 7.62122Z",
    fill: "#3282FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.eb226ca460a19e0943831c83378c66ce.svg";
export { ForwardRef as ReactComponent };